import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "midTitle" }
const _hoisted_3 = { class: "opTableScroller" }
const _hoisted_4 = { class: "opTable table table-striped" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_localized_text, {
        localizedKey: "Acquisti cliente",
        text: "Acquisti cliente"
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data acquisto",
                text: "Data acquisto"
              })
            ]),
            _createElementVNode("td", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carrello",
                text: "Carrello"
              })
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.purchases as OM.Purchase[]), (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.createdOn, 'DD-MM-YYYY HH:mm')), 1),
              _createElementVNode("td", null, [
                _createElementVNode("u", null, [
                  _createTextVNode(_toDisplayString(item.purchasedOffers.length) + " ", 1),
                  _createVNode(_component_localized_text, {
                    localizedKey: "elementi",
                    text: "elementi"
                  })
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.purchasedOffers, (offer, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("small", null, "- " + _toDisplayString(offer.name), 1),
                    _createElementVNode("b", null, "(x" + _toDisplayString(offer.quantity) + ")", 1)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}